import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Form, Input, message } from 'antd'
import { useHistory, Redirect } from 'react-router-dom'
import { Mail, ArrowRight, BarChart3, Shield } from 'lucide-react'
import { AUTH } from '../../utils/apis'
import paths from '../../Config/paths'
import { secureApi } from '../../Config/api'
import '../Login/LoginPage.css'

const ForgotPassword = () => {
    const user = useSelector(state => state.authReducer.user)
    const history = useHistory()

    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)

    if (user) {
        return <Redirect to={paths?.HOME} />
    }

    const handleForgot = async () => {
        try {
            setLoading(true)
            if (!email) {
                message.error('Please enter your email!')
                return
            }

            const response = await secureApi.post(AUTH.FORGOT_PASSWORD, { email })
            if (response?.success) {
                message.success(response?.message)
            } else {
                message.error(response?.message || 'Reset failed')
            }
        } catch (err) {
            message.error(err.response?.data?.message || 'Something went wrong')
        } finally {
            setLoading(false)
        }
    }

    const GotoLogin = () => {
        history.push(paths?.LOGIN)
    }

    const handleKeyPress = (e) => {
        if (e?.key === 'Enter') {
            handleForgot()
        }
    }

    return (
        <div className="login-container">
            <div className="left-section">
                <div className="left-content">
                    <div className="logo-section">
                        <div className="logo-icon">
                            <span className="logo-letter">E</span>
                        </div>
                        <div className="logo-text">
                            <div className="company-name">ELMEC</div>
                            <div className="company-subtitle">ELETTRONICA</div>
                        </div>
                    </div>

                    <div className="welcome-section">
                        <h1 className="main-heading">
                            Forgot your <br />
                            <span className="dashboard-text">Password?</span>
                        </h1>
                        <p className="description">
                            Enter your email to reset your Team Management account password <br />
                            and get back into your dashboard quickly.
                        </p>
                    </div>

                    <div className="features-section">
                        <div className="feature-card">
                            <div className="feature-icon analytics-icon">
                                <BarChart3 size={24} />
                            </div>
                            <div className="feature-content">
                                <h3 className="feature-title">Analytics</h3>
                                <p className="feature-description">Real-time insights and reporting</p>
                            </div>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon security-icon">
                                <Shield size={24} />
                            </div>
                            <div className="feature-content">
                                <h3 className="feature-title">Security</h3>
                                <p className="feature-description">Enterprise-grade protection</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="right-section">
                <div className="login-form-container">
                    <div className="form-header">
                        <h2 className="form-title">Reset Password</h2>
                        <p className="form-subtitle">
                            Enter your registered email to reset your password
                        </p>
                    </div>

                    <Form layout="vertical" className="login-form" onKeyPress={handleKeyPress}>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: 'Please input your email!' },
                                { type: 'email', message: 'Please enter a valid email!' }
                            ]}
                            className="input-group"
                        >
                            <div className="input-wrapper">
                                <Mail className="input-icon" size={20} />
                                <Input
                                    className="form-input"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </Form.Item>

                        <Form.Item>
                            <button
                                type="button"
                                onClick={handleForgot}
                                disabled={loading}
                                className={`submit-button ${loading ? 'loading' : ''}`}
                            >
                                {loading ? 'Processing...' : (
                                    <>
                                        Reset Password
                                        <ArrowRight size={20} />
                                    </>
                                )}
                            </button>
                        </Form.Item>
                    </Form>
                    <div style={{ textAlign: 'center' }}>
                        <p>
                            Already have an account?{' '}
                            <span className="gotoLogin" onClick={GotoLogin}>
                                Login
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword
